// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pill{display:inline-block;padding:4px 10px;border-radius:20px;font-size:12px;font-weight:700;color:#fff;text-align:center}.pill-sm{padding:2px 8px;font-size:10px}.rojo{background-color:#e3342f}.verde{background-color:#38c172}", ""]);
// Exports
module.exports = exports;
